import { cva } from '@/styled-system/css';

export const tableSortIconRecipe = cva({
  base: {
    color: 'Table.SortIcon.icon.default',

    _groupActive: {
      color: 'Table.SortIcon.icon.pressed',
    },
    _groupHover: {
      color: 'Table.SortIcon.icon.hover',
      opacity: 1,
    },
    _groupFocusVisible: {
      opacity: 1,
    },
  },
  variants: {
    selected: {
      true: {
        opacity: 1,
        color: 'Table.SortIcon.icon.selected',
      },
      false: {
        opacity: 0,
      },
    },
  },
});
